import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog } from '@fortawesome/pro-solid-svg-icons';

import Tooltip from 'components/tooltip';
import UserIcon from 'components/user_icon';
import { ProjectDatabaseMemberPropTypes } from 'components/project/prop_types';

export const VISIBLE_USERS_SIZE = 4;

export default function UserIconList({ size, users, onAddClicked, placement = 'top', showHidden = true }) {
  const visibleUsers = showHidden ? users : users.slice(0, VISIBLE_USERS_SIZE);
  const userIcons = visibleUsers.map((user) => {
    return (
      <UserIcon key={user.id} size={size} tooltipPlacement={placement} user={user} />
    );
  });

  let hiddenIcon;
  const hiddenUsers = users.slice(VISIBLE_USERS_SIZE + 1, users.length - 1);
  if (!showHidden && hiddenUsers.length > 0) {
    const tooltip = hiddenUsers.map(user => (<div key={user.id}>{user.name || user.email}</div>));
    hiddenIcon = (
      <Tooltip content={tooltip} dark placement={placement}>
        <div className={classNames('avatar', size && `avatar-${size}`)} name="hidden-users-icon">
          <span className="hidden-user-count">{`+${hiddenUsers.length}`}</span>
        </div>
      </Tooltip>
    );
  }

  return (
    <div className={classNames('avatar-group', size && `avatar-${size}`)}>
      {userIcons}
      {hiddenIcon}
      {onAddClicked &&
        <span className={classNames('avatar', size && `avatar-${size}`)}>
          <span
            className="avatar-image w-100 h-100 btn btn-secondary"
            onClick={onAddClicked}
          >
            <FontAwesomeIcon icon={faCog} size="lg" />
          </span>
        </span>
      }
    </div>
  );
}

UserIconList.propTypes = {
  placement: PropTypes.string,
  showHidden: PropTypes.bool,
  size: PropTypes.string,
  users: PropTypes.arrayOf(ProjectDatabaseMemberPropTypes).isRequired,
  onAddClicked: PropTypes.func
};
